import { render, staticRenderFns } from "./AddPartnerModal.vue?vue&type=template&id=242bc512&scoped=true&class=fill-height&"
import script from "./AddPartnerModal.vue?vue&type=script&lang=ts&"
export * from "./AddPartnerModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddPartnerModal.vue?vue&type=style&index=0&id=242bc512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242bc512",
  null
  
)

export default component.exports